import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { IDataSourceRequest, IDataSourceResult, Academy, CreateUpdateAcademy } from '../models';
import { HelperService } from './helper.service';

@Injectable({ providedIn: 'root' })
export class ProgramAcademyService {
  url = '/program-academies';
  request: IDataSourceRequest;

  constructor(private apiService: ApiService, private helperService: HelperService) {
    this.request = Object.assign({}, this.helperService.request);
  }

  get(): Observable<IDataSourceResult<Academy>> {
    return this.apiService.post(`${this.url}/search`, this.request).pipe(map(data => data.data));
  }

  getById(id: number): Observable<CreateUpdateAcademy> {
    return this.apiService.get(`${this.url}/${id}`).pipe(map(data => data.data));
  }

  create(model: CreateUpdateAcademy): Observable<void> {
    return this.apiService.post(this.url, model);
  }

  update(id: number, model: CreateUpdateAcademy): Observable<void> {
    return this.apiService.put(this.url, id.toString(), model);
  }

  delete(id: number): Observable<void> {
    return this.apiService.delete(`${this.url}/${id}`);
  }

  exportProgramAcademiesExcel(): Observable<any> {
    return this.apiService
      .postWithReponseArrayBuffer(`${this.url}/export-programAcademies-excel/`, this.request)
      .pipe(map(data => data));
  }

  rejectDeleteRequest(id: number): Observable<boolean> {
    return this.apiService.delete(`${this.url}/reject-delete-request/${id}`);
  }
}
